import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../assests/logo-game.jpeg";
import { FiMail, FiPhone, FiMapPin, FiClock } from "react-icons/fi";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
import { fetchAllCategories } from "../api/categories";

const Footer = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const categoryData = await fetchAllCategories();
        setCategories(categoryData);
      } catch (error) {
        console.error("Failed to fetch categories:", error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <>
      <footer className="bg-gray-900 py-12 px-6 border-t border-gray-800">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 items-start">
            <div>
              <div className="flex items-center mb-4">
                <img src={logo} alt="" className="w-10" /> &nbsp;
                <span className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-purple-600">
                  GAME ZTUDIO
                </span>
              </div>
              <p className="text-gray-400 mb-4">
                Your trusted gaming partner 
              </p>
              <div className="flex space-x-4">
                {/* Facebook */}
                <a
                  href="https://www.facebook.com/YourPage"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-blue-500 transition"
                >
                  <FaFacebookF className="text-white text-lg" />
                </a>

                {/* Instagram */}
                <a
                  href="https://www.instagram.com/YourPage"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-pink-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-pink-500 transition"
                >
                  <FaInstagram className="text-white text-lg" />
                </a>

                {/* YouTube */}
                <a
                  href="https://www.youtube.com/YourChannel"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center cursor-pointer hover:bg-red-500 transition"
                >
                  <FaYoutube className="text-white text-lg" />
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-bold mb-4 text-white">Quick Links</h3>
              <ul className="space-y-2 text-gray-400">
                <li>
                  <a href="#home" className="hover:text-cyan-400 transition">
                    Home
                  </a>
                </li>
                <li>
                  <a
                    href="#services"
                    className="hover:text-cyan-400 transition"
                  >
                    Services
                  </a>
                </li>
                <li>
                  <a
                    href="/about-us"
                    className="hover:text-cyan-400 transition"
                  >
                    About
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-bold mb-4 text-white">Categories</h3>
              <ul className="space-y-2 text-gray-400">
                {categories.length > 0 ? (
                  categories.map((category) => (
                    <li key={category._id}>
                      <Link
                        to={`/products/category/${category.slug}`}
                        className="hover:text-cyan-400 transition"
                      >
                        {category.name}
                      </Link>
                    </li>
                  ))
                ) : (
                  <li className="text-gray-600">No categories found</li>
                )}
              </ul>
            </div>

            <div>
              <h3 className="text-lg font-bold mb-4 text-white">
                Contact Info
              </h3>

              <ul className="space-y-3 text-gray-400 text-sm">
                {/* Email */}
                <li className="flex items-center space-x-2">
                  <FiMail className="text-cyan-400" />
                  <a
                    href="mailto:info@gameztudio.com"
                    className="hover:text-cyan-400 transition"
                  >
                    info@gameztudio.com
                  </a>
                </li>

                {/* Phone */}
                <li className="flex items-center space-x-2">
                  <FiPhone className="text-cyan-400" />
                  <a
                    href="tel:+918098044400"
                    className="hover:text-cyan-400 transition"
                  >
                    +91 80980 44400
                  </a>
                </li>

                {/* Shop 1 Address */}
                <li className="flex items-start space-x-2">
                  <FiMapPin className="text-cyan-400 text-2xl mt-1" />
                  <div>
                    {/* <p className="font-semibold text-white">Shop 1:</p> */}
                    <p>
                      1st floor, Jeba Garden, FF 1/7 Corner stone complex, NGO A
                      colony, Tirunelveli
                    </p>
                  </div>
                </li>

                {/* Shop 2 Address */}
                {/* <li className="flex items-start space-x-2">
                  <FiMapPin className="text-cyan-400 mt-1" />
                  <div>
                    <p className="font-semibold text-white">Shop 2:</p>
                    <p>456 Market Road, Coimbatore, Tamil Nadu</p>
                  </div>
                </li> */}

                {/* Timing */}
                <li className="flex items-center space-x-2">
                  <FiClock className="text-cyan-400" />
                  <span>Mon-Sun: 10AM-10PM</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 mt-8 pt-8 text-center">
            {/* <p className="text-gray-400 mb-2">
              © 2025 Game Ztudio. All rights reserved. | Made with AdBrainz & Team
            </p> */}
            <p className="text-center text-sm text-gray-400 mb-2">
              © 2025{" "}
              <span className="text-white font-semibold">Game Ztudio</span>. All
              rights reserved. | Made by{" "}
              <span className="text-cyan-400 font-semibold">
                AdBrainz Team
              </span>
            </p>

            <div className="flex justify-center space-x-4 text-sm">
              <Link
                to="/terms-and-conditions"
                className="text-gray-400 hover:text-cyan-400 transition"
              >
                Terms & Conditions
              </Link>
              <span className="text-gray-500">|</span>
              <Link
                to="/privacy-policy"
                className="text-gray-400 hover:text-cyan-400 transition"
              >
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
